import { ChangeDetectionStrategy, Component } from '@angular/core';

import { CanvasElementComponent } from '../../canvas-elements/element-component';
import { CanvasElementBaseNavigationComponent } from '../__base/base-navigation.component';

@Component({
  selector: 'be-nav-container',
  template: `<div class="nav-slot" [blazeSlotNode]="slots?.slotNodesData?.['nsHostType:Header']">
    <ng-container *ngTemplateOutlet="slots?.templates?.['nsHostType:Header'] || null" />
  </div>`,
  styleUrls: ['./nav-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NavContainerComponent
  extends CanvasElementBaseNavigationComponent<'navContainer'>
  implements CanvasElementComponent<'navContainer'> {}
